export enum WatchingProfileMetricProperties {
  MediaId = 'mediaId',
  ViewedSections = 'viewedSections',
  CurrentPosition = 'currentPosition',
  ProfileId = 'profileId',
  SeriesId = 'seriesId',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
}
export enum WatchingProfileMetricMetaProperties {}
